import { RootState } from '..';

export const selectMixtures = (state: RootState) => state.mixtures.mixtures;

export const selectFilteredMixtures = (state: RootState) =>
  state.mixtures.filteredMixtures;

export const selectMixtureStatuses = (state: RootState) =>
  state.mixtures.mixtureStatuses;

export const selectMixtureAvgParameters = (state: RootState) =>
  state.mixtures.mixtureAvgParameters;

export const selectMixtureStdPractice = (state: RootState) =>
  state.mixtures.mixtureStdPractice;

export const selectMixtureSpecification = (state: RootState) =>
  state.mixtures.mixtureSpecification;

export const selectMixturesRequestState = (state: RootState) =>
  state.mixtures.requestState;

export const selectNumberOfOngoingMixtures = (state: RootState) =>
  state.mixtures.numberOfOngoingMixtures;
